import React from 'react';
import CountUp from '../ui/CountUp';
import AnimatedSection from '../ui/AnimatedSection';
import { keyStats } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const StatsSection = () => {
  const { pick } = useLanguage();
  return (
    <section className="py-20 bg-[#5B7A8A]/10 border-y border-[rgba(91,122,138,0.2)]">
      <div className="container-swg">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {keyStats.map((stat, index) => (
            <AnimatedSection key={index} delay={index * 0.1}>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-[#5B7A8A] mb-2">
                  <CountUp end={stat.value} suffix={stat.suffix} />
                </div>
                <p className="text-[#9AACB8] text-sm md:text-base">{pick(stat.label)}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
